module.exports = __webpack_public_path__ + "img/goods15_1.76b4bec9.jpg";